

import Section1 from '../../Components/section1/section1';
import Section2 from '../../Components/section2/section2';
import SectionCTA from '../../Components/sectionCTA/sectionCTA';
import SectionProducts from '../../Components/sectionProducts/sectionProducts';
import ECPF from '../../Assets/images/tit_02.png'
import ECNPJ from '../../Assets/images/tit_01.png'
import NFE from '../../Assets/images/tit_03.png'
import BG_01 from '../../Assets/images/bg_01.png'
import BG_02 from '../../Assets/images/bg_02.png'

import "./body.css";

import ctPlusLogo from '../../Assets/images/ico_ctplus.png'

function Body({contexto}) {
  document.getElementById('siteTitle').innerHTML = contexto.title;

  return (
    <div className="Body">
      <Section1 
        tituloJson={"e-CNPJ A1"}
        Titulo={"e-CNPJ A1"} 
        texto1={"Garanta já o seu certificado com o preço mais baixo do mercado! Não perca essa oportunidade!"} 
        texto2={"De R$ "}
        texto4={" por apenas R$ "}
        texto5={"O Certificado e-CNPJ tipo A1 é uma ferramenta indispensável para empresas que desejam realizar transações eletrônicas com segurança e agilidade. Com ele, você poderá assinar documentos digitalmente, emitir notas fiscais eletrônicas, acessar sistemas governamentais e muito mais."}
        srcImg={contexto.logo}
        mostraPrecoCheio={contexto.mostraPrecoCheio}
        cor={'#ebf1ff'}
        tipo={3}
        btnHomeTitle={"Compre já!"}
        btnHomeLink={"#enpj"}
      />
      <svg id="bigTriangleColor" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100" viewBox="0 0 100 102" preserveAspectRatio="none">
        <path d="M0 0 L50 100 L100 0 Z"></path>
      </svg>
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center img-ctplus" >
            <img src={ctPlusLogo} alt={'img-ctplus'}/>
          </div>
        </div>
      </div>
      <div className='container' id='ecnpj'>
        <div className='row'>
          <SectionProducts   item={'ECNPJ'} tituloImg={'ECNPJ imagem'} img={ECNPJ} texto={'O e-CNPJ é a identidade digital destinada a pessoas jurídicas, necessária para identifica-las no meio eletrônico e permitir a realização de diversos serviços com integridade e segurança das informações. Com ele é possível assinar documentos digitalmente, transmitir dados, atender aos compromissos fiscais que toda empresa tem com o Governo e ter acesso aos sites da Receita Federal do Brasil (RFB), eSocial, Conectividade Social, entre outros.'}/>
        </div>
      </div>
      <div className='container' id='ecpf'>
        <div className='row'>
          <SectionProducts item={'ECPF'} tituloImg={'ECPF imagem'} img={ECPF} texto={'O e-CPF é a identidade digital destinada a pessoas físicas, necessária para identificá-las no meio eletrônico e permitir a realização de diversos serviços. Com ele é possível assinar documentos digitalmente com validade jurídica e ter acesso aos sites da Receita Federal do Brasil (RFB), eSocial, Conectividade Social, entre outros.'}/>
        </div>
      </div>
      <div className='container' id='nfe'>
        <div className='row'>
          <SectionProducts item={'NFE'} tituloImg={'ECNPJ imagem'} img={NFE} texto={'O NF-e é o certificado digital para empresas que precisam emitir notas fiscais eletrônicas. Com ele a empresa pode de emitir notas fiscais eletrônicas para ser reconhecida pelos órgãos públicos, como a Secretaria da Fazenda do Estado (Sefaz) ou do município (prefeitura), além de fazer diversas outras ações relacionadas à contabilidade.'}/>
        </div>
      </div>
      <Section1 
        Titulo={'Tenha um Certificado Digital'} 

        texto1={'Assine digitalmente contratos com a mesma autenticidade e validade jurídica da assinatura de próprio punho e mantenha os compromissos fiscais da sua empresa em dia com rapidez, segurança e sem burocracia.'} 
        texto2={'O certificado digital é a carteira de identificação eletrônica/virtual de empresas e pessoas físicas. Ele é uma alternativa mais sustentável, moderna e segura aos documentos em papel.'}
        srcImg={'https://sinpejus.ctplus.com.br/images/img_01.jpg'}
        cor={'#fff'}
        tipo={2}
      />
      <SectionCTA Titulo={'Fácil e rápido! Como adquirir um Certificado Digital'} cor={'A'} srcImg={BG_01}/>
      <Section2 Titulo={'Pronto! Seu Certificado Digital estará disponível para uso.'} />
      
      <Section1 
        tituloJson={contexto.title}
        Titulo={contexto.titleParceria} 
        texto1={contexto.descriptionParceria} 
        srcImg={contexto.logo}
        cor={'#ebf1ff'}
        tipo={1}
        btnHomeTitle={contexto.btnHomeTitle}
        btnHomeLink={contexto.btnHomeLink}
      />
    </div>
  );
}

export default Body;